import React, { lazy } from "react";

const Start = lazy(() => import("../pages/start/Start"));
const CityPage = lazy(() => import("../pages/city-page/CityPage"));
const CommunityPage = lazy(() => import("../pages/communities/community-page/CommunityPage"));
const GalleryOfProperty = lazy(() => import("../pages/gallery-of-property/GalleryOfProperty"));
const PropertyFloorPlans = lazy(() => import("../pages/property-floor-plans/PropertyFloorPlans"));
const PropertyVideos = lazy(() => import("../pages/videos-of-property/PropertyVideos"));
const Error = lazy(() => import("../pages/error-page/Error"));
const Admin = lazy(() => import("../pages/admin/Admin"));

export const routesConfig = [
    {
        path: "/",
        element: <Start />,
    },
    {
        path: "/admin/*",
        element: <Admin />,
    },
    {
        path: "/:cityName",
        element: <CityPage />,
    },
    {
        path: "/:cityName/:communityName",
        element: <CommunityPage />,
    },
    {
        path: "/:cityName/:communityName/:propertyName",
        element: <CommunityPage />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/gallery",
        element: <GalleryOfProperty />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/videos",
        element: <PropertyVideos />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/floor-plans",
        element: <PropertyFloorPlans />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/documents",
        element: <PropertyFloorPlans />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/others",
        element: <PropertyFloorPlans />,
    },
    {
        path: "*",
        element: <Error />,
    },
];
